import React from "react";
import PropTypes from "prop-types";
import "./card-share.m.css";

const CardShareTemplate = ({ twitterUrl, fbUrl, mailtoUrl, whatsappUrl }) => {
  return (
    <div styleName="wrapper">
      <a styleName="icon" href={decodeURIComponent(twitterUrl)} target="_blank" rel="noopener noreferrer">
        <i className="ri-twitter-x-fill" id="ri-twitter-x-fill"></i>
      </a>
      <a styleName="icon" href={decodeURIComponent(fbUrl)} target="_blank" rel="noopener noreferrer">
      <i className="ri-facebook-fill" id="ri-facebook-fill"></i>
      </a>
      <a styleName="icon" href={decodeURIComponent(whatsappUrl)} target="_blank" rel="noopener noreferrer">
      <i className="ri-whatsapp-line" id="ri-whatsapp-line"></i>
      </a>
      <a styleName="icon" href={decodeURIComponent(mailtoUrl)} target="_blank" rel="noopener noreferrer">
      <i className="ri-mail-line" id="ri-mail-line"></i>
      </a>
    </div>
  );
};

CardShareTemplate.propTypes = {
  twitterUrl: PropTypes.string,
  fbUrl: PropTypes.string,
  mailtoUrl: PropTypes.string,
  whatsappUrl: PropTypes.string
};

export default CardShareTemplate;
